var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.735 2.506c-.33-.366-.673-.511-.976-.506H3.75a.75.75 0 10.005 1.5h1.566a3.258 3.258 0 00-.586-.994zM5.5 4.5v1H2v-1h3.5zM3 6.5h2.5V10h-2a.5.5 0 01-.5-.5v-3zm.5 4.5A1.5 1.5 0 012 9.5v-3a1 1 0 01-1-1v-1a1 1 0 011-1h.169A1.75 1.75 0 013.746 1c.66-.01 1.26.313 1.732.837.197.219.371.472.522.752.15-.28.325-.533.522-.752C6.994 1.313 7.595.99 8.254 1a1.75 1.75 0 011.577 2.5H10a1 1 0 011 1v1a1 1 0 01-1 1v3A1.5 1.5 0 018.5 11h-5zM9 6.5v3a.5.5 0 01-.5.5h-2V6.5H9zm1-1v-1H6.5v1H10zm-1.755-2h.005a.75.75 0 000-1.5h-.009c-.303-.005-.646.14-.976.506a3.258 3.258 0 00-.586.994h1.566z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--gift-f46ca5d39e466db0698ba0b7c2c59433.svg";
export { SvgIconUiGift as Component };